export let ScheduleFrequencyEnum=/*#__PURE__*/function(ScheduleFrequencyEnum){ScheduleFrequencyEnum["EVERY_DAY"]="EveryDay";return ScheduleFrequencyEnum;}({});